import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppStateHolder } from '../shared/app-state.holder';
import { AppProperty } from '../properties/app.property';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {
  private _router = inject(Router);
  private _appProperty = inject(AppProperty);


  private _amSuiteFilter: BehaviorSubject<string> = new BehaviorSubject<string>("");

  public amSuiteFilter: Observable<string> = this._amSuiteFilter.asObservable();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  public subscribeEventsNavigation(): any {
    this._router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: NavigationEnd) => {
      this._setActions(e.urlAfterRedirects);
    })
  }

  private _setActions(url: string): void {
    switch (url) {
      case "/dashboard":
        this._amSuiteFilter.next("GenericFilter");
        break;
    }
  }
}
